import styled, { css } from 'styled-components'

export const NavbarContainer = styled.nav`
  ${({ theme, forgotDetails }) => css`
    width: 100vw;
    border-bottom: 1px solid ${theme.colors.lightGrey};
    background-color: ${theme.colors.white};
    z-index: 9000;
    position: fixed;
    top: 0;
    left: 0;
    height: ${theme.ToRem(80)};
    padding: 0 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    @media only screen and (min-width: ${theme.ToRem(1024)}) {
      justify-content: flex-start;
    }

    ${forgotDetails &&
    css`
      max-width: 1440px;

      @media only screen and (min-width: ${theme.ToRem(1440)}) {
        left: unset;
      }
    `}
  `}
`

export const NavbarItemsWrapper = styled.div`
  ${({ theme, isAlternativeActive }) => css`
    display: flex;
    align-items: flex-end;
    justify-content: center;
    svg {
      height: ${theme.ToRem(40)};
    }

    img {
      width: auto;
      height: ${theme.ToRem(isAlternativeActive ? 40 : 50)};
    }

    @media only screen and (min-width: ${theme.ToRem(1024)}) {
      svg {
        height: ${theme.ToRem(50)};
      }

      img {
        width: auto;
        height: ${theme.ToRem(isAlternativeActive ? 45 : 50)};
        ${isAlternativeActive &&
        css`
          margin-top: 1rem;
        `}
      }
    }
  `}
`

export const NavbarSubtitle = styled.div`
  ${({ theme }) => css`
    ${theme.fonts.regular};
    color: ${theme.colors.primary.default};
    font-size: ${theme.ToRem(10)};
    margin-bottom: 0.25rem;
    margin-left: 0.5rem;
    display: inline-block;

    @media only screen and (min-width: ${theme.ToRem(768)}) {
      font-size: ${theme.ToRem(16)};
    }
  `}
`
